import { Navigate, Outlet } from "react-router-dom";

const ProtectedAdminRoute = () => {
  const token = localStorage.getItem("cm_admin_token");

  return token ? <Outlet /> : <Navigate to="/admin/login" />;
};

export default ProtectedAdminRoute;
